import { render, staticRenderFns } from "./szxx.vue?vue&type=template&id=68c22d6a&scoped=true&"
import script from "./szxx.vue?vue&type=script&lang=js&"
export * from "./szxx.vue?vue&type=script&lang=js&"
import style0 from "./szxx.vue?vue&type=style&index=0&id=68c22d6a&scoped=true&lang=css&"
import style1 from "./szxx.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c22d6a",
  null
  
)

export default component.exports